const allsections = { data: [], loading: true };
export const GetAllSections = (state = allsections, action) => {
  switch (action.type) {
    case "get_allsections":
      return {
        data: action.payload,
        loading: action.loading,
      };
    default:
      return state;
  }
};
const crmProjects = { data: [], loading: true };
export const GetCrmProjects = (state = crmProjects, action) => {
  switch (action.type) {
    case "get_crmprojects":
      return {
        data: action.payload,
        loading: action.loading,
      };
    default:
      return state;
  }
};
